module.exports = __webpack_public_path__ + "static/media/patrol(19).45bc7d67.PNG";